<div class="container">
  <div
    class="freetext"
    #freeTextContainer
    matTooltip="{{ freeText }}"
    matTooltipPosition="left"
    matTooltipClass="ellipsed-text-mattooltip"
  >
    {{ freeText }}
  </div>
  @if (checkOverflow(freeTextContainer)) {
  <div class="link">
    <a
      (click)="openViewAllTextDialog()"
      i18n="@@FreeTextRendererViewAllTextButton"
      >View All Text</a
    >
  </div>
  }
</div>
